import {
  readShipmentTransportFilter,
  writeShipmentTransportFilter,
} from "../../../../shipment/constants/shipmentBoardLaneMode.js";

const OPTIONS = [
  { value: "all", label: "All" },
  { value: "ocean", label: "Ocean" },
  { value: "air", label: "Air" },
];

/**
 * Filters the shipment list/board by transportation mode.
 */
export function ShipmentTransportModeFilter({ value, onChange }) {
  return (
    <div className="shipmentTransportFilter" role="group" aria-label="Transportation mode">
      {OPTIONS.map(option => (
        <button
          key={option.value}
          type="button"
          className={`milestoneBtn transportFilterBtn${
            value === option.value ? " activeMilestone" : ""
          }`}
          onClick={() => {
            onChange(option.value);
            writeShipmentTransportFilter(option.value);
          }}
        >
          {option.label}
        </button>
      ))}
    </div>
  );
}

export { readShipmentTransportFilter };
